import type { IEngineSpecifications } from '@/interfaces/IEngineSpecifications'
import type { IValueAndUnit } from '@/interfaces/IValueAndUnit'
import Base from '@/models/Base'
import ValueAndUnit from './ValueAndUnit'

class EngineSpecifications extends Base implements IEngineSpecifications {
  summary: string
  brand: string
  aspirationType: string
  blockType: string
  bore: IValueAndUnit<number>
  camType: string
  compressionRatio: number
  cylinders: number
  displacement: IValueAndUnit<number>
  fuelInduction: string
  maxHorsePower: number
  maxTorque: IValueAndUnit<number>
  redlineRPM: number
  stroke: number
  valves: number

  constructor(engineSpecifications?: any) {
    super(engineSpecifications)
    this.summary = engineSpecifications?.summary
    this.brand = engineSpecifications?.brand
    this.aspirationType = engineSpecifications?.aspirationType
    this.blockType = engineSpecifications?.blockType
    this.bore = new ValueAndUnit(engineSpecifications?.bore)
    this.camType = engineSpecifications?.camType
    this.compressionRatio = engineSpecifications?.compressionRatio
    this.cylinders = engineSpecifications?.cylinders
    this.displacement = new ValueAndUnit(engineSpecifications?.displacement)
    this.fuelInduction = engineSpecifications?.fuelInduction
    this.maxHorsePower = engineSpecifications?.maxHorsePower
    this.maxTorque = new ValueAndUnit(engineSpecifications?.maxTorque)
    this.redlineRPM = engineSpecifications?.redlineRPM
    this.stroke = engineSpecifications?.stroke
    this.valves = engineSpecifications?.valves
  }
}

export default EngineSpecifications
